export default function ClassSelectionMob() {
  return null;
}
